export default function AppSection() {
  return (
    <section id="app" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="bg-gradient-to-br from-primary-500 to-primary-600 rounded-2xl p-8 md:p-12 flex flex-col lg:flex-row items-center gap-8 lg:gap-16 overflow-hidden relative">
          <div className="absolute inset-0 opacity-10">
            <div className="absolute top-0 right-0 w-64 h-64 rounded-full bg-background-50/30 blur-3xl"></div>
            <div className="absolute bottom-0 left-0 w-80 h-80 rounded-full bg-background-50/20 blur-3xl"></div>
          </div>

          <div className="relative flex-1 text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-4xl font-black text-background-50 mb-4">
              移动追漫
            </h2>
            <p className="text-background-50/80 text-sm md:text-base leading-relaxed mb-6 max-w-md">
              UU漫画已全面适配移动端，在手机浏览器中即可享受流畅的漫画追更体验。
              连载漫画最新更新随身看，漫画更新提醒实时推送，追漫必备的移动端入口随时为你敞开。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#hero"
                className="inline-flex items-center gap-2 px-7 py-3 bg-background-50 text-primary-600 font-semibold rounded-full hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-smartphone-line"></i>
                立即访问移动版
              </a>
              <a
                href="#features"
                className="inline-flex items-center gap-2 px-7 py-3 bg-primary-400/30 text-background-50 font-semibold rounded-full hover:bg-primary-400/40 transition-colors whitespace-nowrap cursor-pointer text-sm border border-background-50/20"
              >
                <i className="ri-information-line"></i>
                了解更多功能
              </a>
            </div>
          </div>

          <div className="relative flex-shrink-0">
            <div className="w-48 md:w-56 aspect-[9/16] rounded-2xl overflow-hidden border-4 border-background-50/30">
              <img
                src="https://readdy.ai/api/search-image?query=Clean%20mobile%20app%20mockup%20showing%20manga%20reading%20interface%20with%20comic%20page%20display%2C%20warm%20white%20and%20coral%20accent%20UI%2C%20modern%20minimalist%20design%20with%20manga%20list%20and%20reading%20screen%2C%20product%20mockup%20style%20on%20plain%20background&width=450&height=800&seq=app-mobile-mock-01&orientation=portrait"
                alt="UU漫画移动端界面"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}